import React from 'react';

import { SkeletonItem } from '@atlaskit/menu';

export function DefaultFallback() {
	return (
		<>
			<SkeletonItem />
			<SkeletonItem />
			<SkeletonItem />
			<SkeletonItem />
		</>
	);
}
